import {
  Title,
  Text,
  SimpleGrid,
  Card,
  Group,
  ThemeIcon,
} from "@mantine/core";
import { IconPrompt, IconVersions, IconTags, IconTestPipe } from "@tabler/icons-react";

const stats = [
  { label: "Prompts", value: "—", icon: IconPrompt, color: "blue" },
  { label: "Versions", value: "—", icon: IconVersions, color: "teal" },
  { label: "Tags", value: "—", icon: IconTags, color: "grape" },
  { label: "Test Runs", value: "—", icon: IconTestPipe, color: "orange" },
];

export function DashboardPage() {
  return (
    <>
      <Title order={2} mb="md">
        Dashboard
      </Title>
      <Text c="dimmed" mb="xl">
        Welcome to Showrunner — Git for your prompts.
      </Text>

      <SimpleGrid cols={{ base: 1, xs: 2, md: 4 }}>
        {stats.map((stat) => (
          <Card key={stat.label} withBorder padding="lg" radius="md">
            <Group>
              <ThemeIcon variant="light" size="lg" color={stat.color} radius="md">
                <stat.icon size={20} stroke={1.5} />
              </ThemeIcon>
              <div>
                <Text size="xs" c="dimmed" tt="uppercase" fw={700}>
                  {stat.label}
                </Text>
                <Text size="xl" fw={700}>
                  {stat.value}
                </Text>
              </div>
            </Group>
          </Card>
        ))}
      </SimpleGrid>
    </>
  );
}
